import BlogList from "../components/blogContainer/BlogList";
import Sidebar from "../components/sidebar/Sidebar";

const Home = () => {
  return (
    <section className="wrapper">
      <Sidebar />
      <BlogList />
    </section>
  );
};

export default Home;
